import { OktonSimpleCrudList } from '@okton/platform-ui';
import { Target } from 'lucide-react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import BankAppPage from '../../layout/BankAppPage';
import {
  useDeleteCentroCusto,
  useCentrosCusto,
} from '../../services/hooks/useCadastros';

const CentrosCusto = () => {
  const history = useHistory();
  const {
    data: centrosCusto = [],
    isLoading,
    isError,
    refetch,
  } = useCentrosCusto();
  const deleteMutation = useDeleteCentroCusto();

  return (
    <BankAppPage>
      <>
        <OktonSimpleCrudList
          horizontalSpacing={0}
          title="Centros de Custo"
          description="Classificação de custo dos lançamentos"
          newLabel="Novo Centro de Custo"
          onNew={() => history.push('/centros-custo/novo')}
          onEdit={id => history.push(`/centros-custo/${id}`)}
          icon={Target}
          emptyMessage="Nenhum centro de custo cadastrado"
          items={centrosCusto.map(c => ({ id: c.id_cdc, name: c.nome_cdc }))}
          loading={isLoading}
          error={isError}
          onRetry={refetch}
          onDelete={id => deleteMutation.mutateAsync(id)}
          deleteConfirmation="Excluir este Centro de Custo do IFLEX?"
        />
      </>
    </BankAppPage>
  );
};

export default CentrosCusto;
